module.exports = __webpack_public_path__ + "static/media/topcon.0e520e3a.png";